// extracted by mini-css-extract-plugin
module.exports = {"expand":"Contents_expand__2ZZDE","managerBox":"Contents_managerBox__1qfmG","sidebarSize":"Contents_sidebarSize__1eSoW"};